import $ from 'jquery';

const headerEl = '.header';
const navEl = '.nav';
const navSliderEl = '.nav__slider';

$(window).on('load scroll', () => {
  if ($(window).scrollTop() > 100) {
    if (!$(headerEl).hasClass('scroll')) {
      $(headerEl).addClass('scroll');
    }

    if (!$(navEl).hasClass('scroll')) {
      $(navEl).addClass('scroll');
    }

    if (!$(navSliderEl).hasClass('scroll')) {
      $(navSliderEl).addClass('scroll');
    }
  } else {
    $(headerEl).removeClass('scroll');
    $(navEl).removeClass('scroll');
    $(navSliderEl).removeClass('scroll');
  }
});
